import { HomeEvalResultDetails } from '@/components/homeEval/HomeEvalResultDetails';
import { Card, CardContent } from '@/components/ui/card';
import { homeEvalResultsState } from '@/state';
import { useLoadableAtomValue } from '@/state/loadableHooks';
import type { ConsiderationType, HomeEvalResultId } from '@rock/types';
import type { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const HomeEvalResultEntry: FC<{
    considerationType: ConsiderationType;
}> = ({ considerationType }) => {
    const typeId = considerationType.id;
    const { resultId: selectedResultId } = useParams<{ resultId?: HomeEvalResultId }>();
    const [results, resultsLoadable] = useLoadableAtomValue(homeEvalResultsState(typeId), []);
    const selectedResult = selectedResultId ? results.find((r) => r.id === selectedResultId) : undefined;
    const navigate = useNavigate();

    if (!selectedResult) {
        return (
            <Card>
                <CardContent className="p-6">
                    {resultsLoadable.state === 'loading'
                        ? 'Loading ...'
                        : `Home eval result not found (ID: ${selectedResultId}).`}
                </CardContent>
            </Card>
        );
    }

    return <HomeEvalResultDetails result={selectedResult} onBack={() => navigate(-1)} />;
};
